import React from 'react';

/** ****************************** COMPONENTS  *********************88 */
import Card from 'components/Cards/Card';
import FilterSearchBar from '../User/components/FilterSearchBar';
import CustomTable from 'components/Table/CustomTable';
import mixpanel from 'assets/img/mixpanel.png';

/** ************ components  ************************************* */
import { Textarea , Box, Button, SimpleGrid, ModalFooter, IconButton, Slide, Modal, ModalOverlay, ModalContent , ModalHeader, ModalCloseButton, ModalBody } from '@chakra-ui/react';
import { useGetAllRealtorsQuery, useSuspectToggleRaltorDetailsMutation } from 'reducers/realtor.service';
import { allRealtorHeader } from 'components/Table/Headers/Company/companyTableHeader';
import { MdBlock } from 'react-icons/md';
import { CgDetailsMore } from 'react-icons/cg';
import { useHistory } from 'react-router-dom';

import { IoRefresh } from 'react-icons/io5';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { REALTOR_TYPE } from 'constants/index';
/** **********************************  component   ************************** */
const tableActions = ({ handleAction, handleView }) => {
    const Action = (value, row) => (
        <div>
            <IconButton
                aria-label="View on Mixpanel"
                icon={<img src={mixpanel} alt="Mixpanel" style={{ width: '1.5rem', height: '1.5rem' }} />}
                variant="ghost"
                onClick={() => window.open(`https://mixpanel.com/project/3702032/view/4200228/app/profile#distinct_id=${row?._id}`, '_blank', 'noreferrer')}
            />

            <IconButton onClick={() => handleAction(row)} colorScheme={row?.isSuspendedByAdmin ? 'green' : 'red'} variant='solid' ml={2} size='sm'>
                {
                    row.isSuspendedByAdmin
                        ? <IoRefresh/>
                        : <MdBlock/>

                }

            </IconButton>

            <IconButton
                aria-label="View on Mixpanel"
                icon={<CgDetailsMore/>}
                variant="ghost"
                onClick={()=> handleView(row)}
            />
        </div>
    );
    return Action;
};

const RealtorHome = () => {
    const history = useHistory();
    const location = useLocation();

    const { data, refetch, isLoading,isError, isFetching } = useGetAllRealtorsQuery({ query: location.search }, {
        skip: false,
        refetchOnMountOrArgChange: true
    });

    const handleAction = (row) => {
        setisOpen(true);
        setcurrow(row);
        setaction(row?.isSuspendedByAdmin ? 'UNSUSPEND' : 'SUSPEND');
    };
    const handleView = (row)=>{
        history.push('/organization/user/realtor/' + row._id);
    };
    const realtorTableHeader = allRealtorHeader({ tableActions: tableActions({ handleAction, handleView }) });
    const [suspendToggle, { isLoading: isSubmitLoading }] = useSuspectToggleRaltorDetailsMutation();

    const [currow, setcurrow] = React.useState(null);
    const [message, setmessage] = React.useState('');
    const [isOpen, setisOpen] = React.useState(false);
    const [action, setaction] = React.useState('SUSPEND');

    const handleClose = () => {
        setcurrow(null);
        setaction('SUSPEND');
        setisOpen(false);
        setmessage('');
    };
    const handleChange = (e) => {
        let { value } = e.target;
        setmessage(value);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        suspendToggle({ id: currow.id, body: { message, action }, query: location.search }).unwrap().then(() => {
            handleClose();
        });
    };

    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <Slide direction='top' in={isOpen} >
                <Modal isCentered size='xl' blockScrollOnMount={false} isOpen={isOpen} onClose={handleClose} >
                    <ModalOverlay />
                    <ModalContent>
                        <form
                            onSubmit={handleSubmit}
                            name="user-edit-form"
                            className="full-width"
                        >
                            <ModalHeader textTransform={'capitalize'}>{ action.toLowerCase()} Realtor</ModalHeader>
                            <ModalCloseButton />
                            <ModalBody>
                                <label htmlFor="message">Are you sure you want to {action.toLowerCase() } realtor?</label>
                                <Textarea
                                    value={message }
                                    onChange={handleChange}
                                    placeholder="Message..."
                                    name="message"
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button mr={3} onClick={handleClose}>
                                Close
                                </Button>
                                <Button type='submit' isLoading={isSubmitLoading} loadingText={'Sending.. '} variant='brand'>
                                Submit
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalContent>

                </Modal>
            </Slide>

            <SimpleGrid
                mb="20px"
                columns={{ sm: 1, md: 1 }}
                spacing={{ base: '20px', xl: '20px' }}
            >
                <Card>
                    <FilterSearchBar
                        isPercentage={false}
                        isStatus={true}
                        downloadType={REALTOR_TYPE}
                        onRefresh={refetch}
                    />
                    <div className="page-main-box">
                        <CustomTable
                            rowStyle={{ cursor: 'pointer' }}
                            handleRefresh={refetch}
                            data={data || []}
                            showFilters = { false}
                            columns={realtorTableHeader}
                            isError={isError}
                            isLoading={isLoading || isFetching }
                        />
                    </div>
                </Card>
            </SimpleGrid>

        </Box>
    );
};

export default RealtorHome;
